import { Animated } from 'react-native';
import styled from 'styled-components/native';

export default styled(Animated.FlatList)`
  z-index: 1;
`;
